import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TrReceiptComponent } from './tr-receipt.component';
import { RouterModule } from '@angular/router';
import { HubLogoModule } from '../../hub-logo/hub-logo.module';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        RouterModule,
        HubLogoModule,
        SvgIconModule,
    ],
    exports: [ TrReceiptComponent ],
    declarations: [ TrReceiptComponent ],
    entryComponents: [ TrReceiptComponent ],
})
export class TrReceiptModule {}
